import React from 'react';
import { Flex, Text } from '../../ui-kit';
import { Icon, LoyaltySavePoints, LoyaltySavePointsErrorIcon } from '../assets/styles';
import { LOYALTY_IMAGES } from '../assets/images';
import theme from '../../ui-kit/themes/theme';
import * as COPY from '../utilities/copy';
import Radio from '../../ui-kit/Radio';
import { editCopyByReplaceWithComponent } from '../../utilities/copyFunctions';
import CloseIcon from '../../ui-kit/icons/Close';
import { pushEvent } from '../../../utilities/dataLayerUtils';

const RADIO_IDS = {
  USE_POINTS: 'use-points',
  SAVE_POINTS: 'save-points'
};

const LoyaltySavePointsRadioButton = ({
  checked = null,
  setChecked = () => {},
  points,
  updateSavePointsForLater = () => {},
  checkedError = false,
  setCheckedSavePointsError = () => {}
}) => {
  const onChange = e => {
    setChecked(e.target.id);
    let shouldSavePointsForLater = e.target.id === RADIO_IDS.SAVE_POINTS;
    if (checkedError) {
      setCheckedSavePointsError(false);
    }

    pushEvent({
      event: 'custom_click',
      click_type: shouldSavePointsForLater ? 'save points' : 'apply points',
      click_category: 'voyagers points checkout'
    });

    updateSavePointsForLater(shouldSavePointsForLater);
  };
  const pointsToSave = <b>${points.toFixed(2)}</b>;
  return (
    <LoyaltySavePoints>
      <Flex gap="12px" alignItems="center" background={theme.colors.deepForestGreen[100]} p={3}>
        <Icon size="32px" src={LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_GREEN} alt="Loyalty" />
        <Text color="voyagersMoonlight" lineHeight="150%" fontSize={2} fontWeight="medium">
          {COPY.AVAILABLE_POINTS}
        </Text>
      </Flex>
      <Flex flexDirection="column" gap="17px" p={3}>
        <Radio
          error={checkedError && !checked}
          checked={checked === RADIO_IDS.USE_POINTS}
          id={RADIO_IDS.USE_POINTS}
          name="savePoints"
          onChange={onChange}>
          {editCopyByReplaceWithComponent(COPY.USE_POINTS, pointsToSave, '<POINTS>')}
        </Radio>
        <Radio
          error={checkedError && !checked}
          checked={checked === RADIO_IDS.SAVE_POINTS}
          id={RADIO_IDS.SAVE_POINTS}
          name="savePoints"
          onChange={onChange}>
          {COPY.SAVE_POINTS}
        </Radio>
        {checkedError && !checked ? (
          <Flex gap="12px" alignItems="center">
            <LoyaltySavePointsErrorIcon>
              <CloseIcon size={10} color={theme.colors.pureWhite[0]} />
            </LoyaltySavePointsErrorIcon>
            <Text fontSize={[9, 9, 9, 0]} fontWeight="bold" color={theme.colors.errorOrange}>
              {COPY.SAVE_POINTS_ERROR}
            </Text>
          </Flex>
        ) : null}
      </Flex>
    </LoyaltySavePoints>
  );
};

export default LoyaltySavePointsRadioButton;
